import React from 'react';
import { Toolbar, Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import VerifyEmail from './pages/auth/VerifyEmail';
import {LanguageProvider } from "./contexts/LanguageContext";
import ChangePassword from './pages/auth/ChangePassword';
import ValidateEmail from './pages/auth/ValidateEmail';
import LoadingOverlay from './components/LoadingOverlay';
import AppSnackbar from './components/ErrorSnackbar';
import MarketingPage from './pages/home/MarketingPage';
import { useAppContext } from './contexts/AppContext';
import StoreCreation from './pages/store-creation/StoreCreation';
import AppAppBar from './components/AppAppBar';
import AppTheme from './theme/AppTheme';
import CssBaseline from '@mui/material/CssBaseline';
import Dashboard from './pages/home/Dashboard';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import StoreEdit from './pages/store-edit/StoreEdit';

function App() {
  const { appState } = useAppContext();

  return (
    <LanguageProvider> {/* ✅ Wrap App with LanguageProvider */}
      <Router>
        <LoadingOverlay />
        <AppSnackbar />
        <AppTheme>
          <CssBaseline enableColorScheme />
          <AppAppBar />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />

            <Routes>
              <Route path="/" element={appState.isAuthenticated ? <Navigate to="/home" replace /> : <MarketingPage />} />
              <Route
                path="/terms-and-conditions"
                element={
                  <>
                    <AppAppBar hideNavigation hideAuthButtons />
                    <TermsAndConditions />
                  </>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <>
                    <AppAppBar hideNavigation hideAuthButtons />
                    <PrivacyPolicy />
                  </>
                }
              />
              <Route
                path="/signin"
                element={
                  <>
                    <AppAppBar hideNavigationOnly />
                    <SignIn />
                  </>
                }
              />
              <Route
                path="/signup"
                element={
                  <>
                    <AppAppBar hideNavigationOnly />
                    <SignUp />
                  </>
                }
              />
              {/* <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/validate-email" element={<ValidateEmail />} />
              <Route path="/home" element={ <Dashboard />} />
              <Route path="/store-creation" element={ <StoreCreation />} />
              <Route path="/store-edit/:storeId" element={ <StoreEdit />} /> */}
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/validate-email" element={<ValidateEmail />} />
              <Route path="/home" element={appState.isAuthenticated ? <Dashboard /> : <Navigate to="/signin" replace />} />
              <Route path="/store-creation" element={appState.isAuthenticated ? <StoreCreation /> : <Navigate to="/signin" replace />} />
              <Route path="/store-edit/:storeId" element={appState.isAuthenticated ? <StoreEdit /> : <Navigate to="/signin" replace />} />
            </Routes>
          </Box>
        </AppTheme>
      </Router>
    </LanguageProvider>
  );
}

export default App;
